import { api } from "./authService";

const classService = {
  // Get my classes (classes where user is a member)
  getMyClasses: async () => {
    try {
      const response = await api.get("/classes/my-classes");
      return response.data;
    } catch (error) {
      console.error("Error fetching my classes:", error);
      throw error;
    }
  },

  // Get classes for a specific user (Admin/Berufsbildner only)
  getClassesByUserId: async (userId) => {
    try {
      const response = await api.get(`/classes/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching classes for user ${userId}:`, error);
      throw error;
    }
  },

  // Get classes with filters
  getClasses: async (params = {}) => {
    try {
      const response = await api.get("/classes", { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get class by ID
  getClassById: async (id) => {
    try {
      const response = await api.get(`/classes/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new class
  createClass: async (classData) => {
    try {
      const response = await api.post("/classes", classData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update class
  updateClass: async (id, classData) => {
    try {
      const response = await api.put(`/classes/${id}`, classData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete class
  deleteClass: async (id) => {
    try {
      await api.delete(`/classes/${id}`);
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getDeleteImpact: async (id) => {
    try {
      const response = await api.get(`/classes/${id}/delete-impact`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get students by class
  getStudentsByClass: async (classId, config = {}) => {
    try {
      const response = await api.get(`/classes/${classId}/students`, config);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update class subjects
  updateClassSubjects: async (id, subjectIds) => {
    try {
      await api.put(`/classes/${id}/subjects`, { subjectIds });
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get class members
  getClassMembers: async (id, params = {}) => {
    try {
      const response = await api.get(`/classes/${id}/learners`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Add members to class
  addMembersToClass: async (id, userIds) => {
    try {
      const response = await api.post(`/classes/${id}/enrollments`, {
        userIds,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Remove member from class
  removeMemberFromClass: async (classId, userId) => {
    try {
      await api.delete(`/classes/${classId}/enrollments/${userId}`);
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get learners for assignment
  getLearners: async (params = {}) => {
    try {
      const response = await api.get("/learners", { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get subjects (assuming there's a subjects endpoint)
  getSubjects: async (params = {}) => {
    try {
      const response = await api.get("/subjects", { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all classes
  getAllClasses: async () => {
    try {
      const response = await api.get("/classes");
      return response.data;
    } catch (error) {
      console.error("Error fetching all classes:", error);
      throw error.response?.data || error.message;
    }
  },

  // Get classes by school
  getClassesBySchool: async (schoolId) => {
    try {
      const response = await api.get(`/schools/${schoolId}/classes`);
      return response.data;
    } catch (error) {
      console.error("Error fetching classes by school:", error);
      throw error.response?.data || error.message;
    }
  },
};

export default classService;
